import React, { ReactNode } from "react";
import SubscriptionCard from "./components/SubscriptionCard";
import Hero from "../../components/Hero";
import MainButton from "../../components/buttons/MainButton";
const urlParams = new URLSearchParams(window.location.search);
const status = urlParams.get("status");

const ProductSuccess = () => {
  return (
    <>
      <section className="success-message-page">
        <div className={"container"}>
          <div className={"mb-5"}>
            <Hero
              text={`  ${
                status == "success"
                  ? "You Purchased Successfull"
                  : "Your Purchase cancelled Please try again"
              }`}
            />
          </div>
          {status == "success" ? (
            <div className="row mb-5 justify-content-center">
              <div className="col-md-8">
                <div className={"bg-form bdr-21"}>
                  <div className={"main-title primary-text fs-35 pt-5"}>
                    Next Steps
                  </div>
                  <p className={"text-center tg-d fs-14"}>
                    To receive a certificate of purchase and information on the
                    NFT airdrop.
                  </p>
                  <div>
                    <div className={"row justify-content-center mt-3"}>
                      <div className={"col-md-12 mt-3"}>
                        <div
                          className={
                            "bg-light-2 bg-box-shadow-light p-lg-5 p-4 bdr-21"
                          }
                        >
                          <span
                            className={
                              "main-title primary-text fs-25 letter-spacing me-2"
                            }
                          >
                            {" "}
                            Step 1:
                          </span>
                          <span
                            className={
                              "main-title primary-text fs-25 letter-spacing f-regular text-capitalize"
                            }
                          >
                            Create Wallet
                          </span>
                          <br />
                          <div className={"row"}>
                            <div className={"col-lg-12 col-12 mb-2"}>
                              <span className={"text-center tg-d fs-14"}>
                                Create A DucatusX Wallet To Generate A Receiving
                                Wallet Address Web Wallet through either:
                              </span>
                            </div>
                            <div className="col-lg-4 mt-4 text-lg-start text-center">
                              <a
                                className={"link sm"}
                                target={"_blank"}
                                rel="noreferrer"
                                href={"http://wallet.ducatus.io"}
                              >
                                <img
                                  src={"/assets/images/icons-2/ducatus.png"}
                                  className="w-75"
                                  alt={"Ducatusx Wallet"}
                                />
                              </a>

                              <div>
                                <img
                                  className={"text-center mt-3"}
                                  src={`/assets/images/icons/phone-qr.png`}
                                  alt={"QR code Garden of Life"}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 mt-4 text-lg-start text-center">
                              <a
                                className={"link sm"}
                                rel="noreferrer"
                                target={"_blank"}
                                href={
                                  "https://apps.apple.com/de/app/ducatus-wallet-2-0/id1489722627"
                                }
                              >
                                <img
                                  src={"/assets/images/icons-2/app-store.png"}
                                  className="w-50 "
                                  alt={"App Store Garden of Life"}
                                />
                              </a>

                              <div>
                                <img
                                  className={"w-50 mt-3"}
                                  src={`/assets/images/icons/qr.png`}
                                  alt={"Garden Of Life"}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 mt-4 text-lg-start text-center">
                              <a
                                className={"link sm"}
                                rel="noreferrer"
                                target={"_blank"}
                                href={
                                  "https://play.google.com/store/apps/details?id=io.ducatus.walnew&hl=de_AT&gl=US&pli=1"
                                }
                              ></a>
                              <img
                                src={"/assets/images/icons-2/play-store.png"}
                                className="w-50 "
                                alt={"Play Google Garden of Life"}
                              />

                              <div>
                                <img
                                  className={"w-50 mt-3"}
                                  src={`/assets/images/icons/qr-code-google-play.png?v=2`}
                                  alt={"Garden Of Life"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={"row mt-3"}>
                        <div className="col-lg-12">
                          <div className={"p-lg-5 p-4"}>
                            <h3
                              className={
                                "text-start main-title primary-text fs-25 letter-spacing mt-3"
                              }
                            >
                              {" "}
                              Step 2:
                              <span
                                className={
                                  "main-title primary-text fs-25 letter-spacing f-regular text-capitalize ms-2"
                                }
                              >
                                Send Wallet Address
                              </span>
                            </h3>

                            <div className={"steps-text mt-3"}>
                              Send the following information via email to{" "}
                            </div>
                            <div className={"steps-text mt-3"}>
                              A) Proof of payment <br />
                              B) DucatusX receiving wallet address
                            </div>
                            <div className="dark-separataor mt-5 " />
                          </div>
                        </div>
                      </div>

                      <div className={"row mb-5"}>
                        <div className="col-lg-12">
                          <div
                            className={
                              "ps-lg-5 pe-lg-5 pt-lg-2 pb-lg-5 ps-4 pe-4 pt-2 pb-4"
                            }
                          >
                            <h3
                              className={
                                "text-start main-title primary-text fs-25 letter-spacing mt-3"
                              }
                            >
                              {" "}
                              Step 3:
                              <span
                                className={
                                  "main-title primary-text fs-25 letter-spacing f-regular text-capitalize ms-2"
                                }
                              >
                                {" "}
                                Confirmation
                              </span>
                            </h3>

                            <div className={"steps-text mt-3"}>
                              Once Your Payment is Confirmed, You Receive A
                              Certificate Of Purchase And Information On The NFT
                              Airdrop
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </section>
    </>
  );
};

export default ProductSuccess;
